import { lazy, Suspense } from "react";
import type { LocationFieldsProps } from "./terra-boa-location-fields";
import { loadBrazilMunicipalities } from "./terra-boa-locations";

const LazyLocationFields = lazy(async () => {
  const [fields] = await Promise.all([
    import("./terra-boa-location-fields"),
    loadBrazilMunicipalities(),
  ]);
  return { default: fields.LocationFields };
});

export function DeferredLocationFields(props: LocationFieldsProps) {
  return <Suspense fallback={<div className="location-fields-loading" role="status">Preparando campos de localização…</div>}>
    <LazyLocationFields {...props} />
  </Suspense>;
}
